import React from "react";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import SelectField from "material-ui/SelectField";

export const renderTextField = (field) => {
  return (
    <TextField
      floatingLabelText={field.label}
      errorText={field.meta.error}
      {...field}
    />
  );
};

export const renderCheckbox = (field) => (
  <Checkbox
    label={field.label}
    checked={field.input.value ? true : false}
    onCheck={field.input.onChange}
  />
);

export const renderSelectField = (field) => (
  <SelectField
    floatingLabelText={field.label}
    floatingLabelFixed
    errorText={field.meta.touched && field.meta.error}
    {...field}
    onChange={(event, index, value) => field.input.onChange(value)}
  />
);

export const required = (value) =>
  value == null || "" === value ? "Obligatoire" : undefined;

export const email = (value) =>
  value !== undefined &&
  value !== null &&
  value.length !== 0 &&
  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Adresse email invalide"
    : undefined;

export const multipleEmails = (value) => {
  if (value === undefined || value === null || value.length === 0) {
    return undefined;
  }
  const emails = value.split(",").map((x) => x.replace(/\s/g, ""));
  const emailsValid = emails.reduce((acc, cur) => {
    return acc && email(cur) === undefined;
  }, true);
  return emailsValid ? undefined : "Adresses email invalides";
};

export const emailArray = (value) => {
  if (value === undefined || value === null || value.length === 0) {
    return undefined;
  }
  const emails = value.split(";").map((x) => x.replace(/\s/g, ""));
  const emailsValid = emails.reduce((acc, cur) => {
    return acc && email(cur) === undefined;
  }, true);
  return emailsValid ? undefined : "Adresses email invalides";
};

export const isFloat = (value) =>
  value == null || "" === value || !isNaN(parseFloat(value))
    ? undefined
    : "Nombre obligatoire";

export const isInteger = (value) =>
  value == null || "" === value || /^\+?(0|[1-9]\d*)$/.test(value)
    ? undefined
    : "Nombre entier obligatoire";

export const maxLength = (max) => (value) =>
  value && value.length > max ? `Maximum ${max} caractères` : undefined;

export const minLength = (min) => (value) =>
  value && value.length < min ? `Minimum ${min} caractères` : undefined;

export const slug = (existingSlugs = []) => (value) => {
  if (existingSlugs.indexOf(value) !== -1) {
    return "Ce slug existe déjà";
  } else {
    value !== undefined &&
    value !== null &&
    value.length !== 0 &&
    !/^[A-Z0-9\-]*$/i.test(value)
      ? "Slug invalide"
      : undefined;
  }
};

export const validators = (xs) => (value) => {
  const validator = xs[0];
  if (!validator) return undefined;
  const validation = validator(value);
  return validation ? validation : validators(xs.slice(1))(value);
};



// WEBPACK FOOTER //
// ./src/services/form.js